import type { ReceiptTemplate } from '../schema';

export const mcdonaldsTemplate: ReceiptTemplate = {
  id: 'mcdonalds',
  name: "McDonald's Receipt",
  brand: "McDONALD'S",
  description: 'Fast food restaurant receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'mcd-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/mcdonalds.png',
        logoData: '',
        logoWidth: 80,
        logoHeight: 70,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          "McDonald's #12847",
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'mcd-order',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Order #247',
        fontSize: 18,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'mcd-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'DINE IN\n01/04/26  12:34:18  KS#3',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'mcd-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'mcd-item-1', name: 'BIG MAC MEAL', quantity: '1', price: '11.99'},
          { id: 'mcd-item-2', name: '  MED FRIES', quantity: '1', price: '0.00'},
          { id: 'mcd-item-3', name: '  MED COKE', quantity: '1', price: '0.00'},
          { id: 'mcd-item-4', name: '10PC MCNUGGETS', quantity: '1', price: '5.99'},
          { id: 'mcd-item-5', name: 'MCFLURRY OREO', quantity: '1', price: '4.89'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'mcd-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'mcd-subtotal', label: 'Subtotal', value: '22.87', isBold: false, isLarge: false },
          { id: 'mcd-tax', label: 'Tax', value: '2.03', isBold: false, isLarge: false },
          { id: 'mcd-total', label: 'Total', value: '24.90', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'mcd-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'mcd-card', label: 'VISA', value: '************4144' },
          { id: 'mcd-auth', label: 'AUTH', value: '847291' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'mcd-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '128470247010426',
        showValue: false,
        width: 1.5,
        height: 35,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'mcd-survey',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: "TELL US ABOUT YOUR VISIT\nMCDVOICE.COM\nVALIDATION CODE: 12847-24718\n\ni'm lovin' it",
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

